import { CART_CONSTANTS, CONFIG_CONSTANTS, STORE_CONSTANTS } from '../actionTypes'

const initState = {
	showPageLoader: false,
	showBtnLoader: false,
	show_back_btnLoader: false,
	showLoadingScreen: false,
}

const loadingReducer = (state = initState, action) => {
	switch (action.type) {
		case 'RESET':
			return initState
		case STORE_CONSTANTS.SHOP_LISTING_REQUEST:
			return {
				...state,
				showLoadingScreen: true,
			}
		case STORE_CONSTANTS.SHOP_LISTING_SUCCESS:
			return {
				...state,
				showLoadingScreen: false,
			}
		case STORE_CONSTANTS.SHOP_LISTING_FAILURE:
			return {
				...state,
				showLoadingScreen: false,
			}
		case CONFIG_CONSTANTS.STORE_CONFIGURATION_REQUEST:
			return {
				...state,
				showLoadingScreen: true,
			}
		case CONFIG_CONSTANTS.STORE_CONFIGURATION_SUCCESS:
			return {
				...state,
				showLoadingScreen: false,
			}
		case CONFIG_CONSTANTS.UPDATED_STORE_CONFIGURATION_SUCCESS:
			return {
				...state,
				showLoadingScreen: false,
			}
		case CONFIG_CONSTANTS.STORE_CONFIGURATION_FAILURE:
			return {
				...state,
				showLoadingScreen: false,
			}
		case CONFIG_CONSTANTS.STORE_CATALOG_INFO_REQUEST:
			return {
				...state,
				showLoadingScreen: true,
			}
		case CONFIG_CONSTANTS.STORE_CATALOG_INFO_SUCCESS:
			return {
				...state,
				showLoadingScreen: false,
			}
		case CONFIG_CONSTANTS.STORE_CATALOG_INFO_FAILURE:
			return {
				...state,
				showLoadingScreen: false,
			}
		case CART_CONSTANTS.CREATE_CATALOG_ORDER_REQUEST:
			return {
				...state,
				showPageLoader: true,
			}
		case CART_CONSTANTS.CREATE_CATALOG_ORDER_SUCCESS:
			return {
				...state,
				showPageLoader: true,
			}
		case CART_CONSTANTS.CREATE_CATALOG_ORDER_FAILURE:
			return {
				...state,
				showPageLoader: false,
			}
		default:
			return state
	}
}
export default loadingReducer
